import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';

export interface Communitys {
  community_id: string;
  community_name: string;
  community_title: string;
  community_tabName: string;
  community_tabId: string;
  community_text: string;
  community_sort: number;
  community_status: boolean;
  community_tabStatus: boolean;
}

const SETTINGS_KEY = 'React-ts-ant-Community';

const localSettings = LocalStore.getValue<Communitys>(SETTINGS_KEY) || {};

export const defaults: Communitys = {
  community_id: '',
  community_name: '',
  community_title: '',
  community_tabName: '',
  community_tabId: '0',
  community_text: '',
  community_sort: 4,
  community_status: false,
  community_tabStatus: false,
  ...localSettings
};

const UPDATE_COMMUNITY = 'UPDATE_COMMUNITY';

export const updateLayoutCommunitys: (communitys: Communitys) => IAction<Communitys> = (communitys: Communitys) => ({
  type: UPDATE_COMMUNITY,
  payload: communitys
});

const communityReducer: Reducer<Communitys, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case UPDATE_COMMUNITY:
      LocalStore.setValue(SETTINGS_KEY, payload as Communitys);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default communityReducer;
